import Vue from 'vue';
import vuesax from 'vuesax';
import VueCarousel from 'vue-carousel';
import axios from 'axios';

window.axios = axios;
window.Viewport = require('./Viewport').default;
window._ = require('lodash');

Vue.use(VueCarousel);
Vue.use(vuesax);

// Directives
import clickOutsideDirective from './directives/click-outside';
import clientClickOutsideDirective from './directives/client-click-outside';

Vue.directive('click-outside', clickOutsideDirective);
Vue.directive('client-click-outside', clientClickOutsideDirective);

// Components
import PrimaryButton from './components/Button.vue';
import StandardSearch from './components/StandardSearch.vue';
import Autocomplete from './components/Autocomplete.vue';
import CompanyJobsCdljnViewMore from './jobs/components/CompanyJobsCdljnViewMore.vue';

const minifiedApp = new Vue({
  el: '#app-min',

  components: {
    PrimaryButton,
    StandardSearch,
    Autocomplete,
    CompanyJobsCdljnViewMore,
  },

  data() {
    return {
      navOpen: false,
    };
  },

  methods: {
    toggleNav() {
      this.navOpen = !this.navOpen;

      if (this.navOpen) {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.left = '0';
        document.body.style.right = '0';
      } else {
        document.body.style.overflow = '';
        document.body.style.position = 'static';
      }
    },
  },
});

export default minifiedApp;
